<template>
  <div class="checking_list">
             <div>
                <back-container :link="'/patients/'+$route.params.township_id+'/township'"></back-container>
            </div>
            <div class="center">
                    <h5>Only Refer Patient</h5>
                    <router-link :to="'/refer/new/'+$route.params.township_id" class="btn blue darken-3">Add new</router-link>
                    <router-link :to="'/refer/trash/'+$route.params.township_id" class="btn blue darken-3">Trash</router-link>
                    <button @click="excelExport"    class="btn green darken-3">Excel Export</button>
            </div>
           <div class="row center">
                             <div class="card card-content "  style="margin-top:30px;max-width:100%;overflow-x: auto;">
                    
                    
                    <table class="app-table">
                        <thead>
                            <tr>
                                <th>No</th><th>Name</th><th>Phone</th>
                                <th>Age</th><th>PhoneID</th>
                                
                                
                                <th>Actions</th>
                                
                            </tr>
                            </thead>
                            
                            <tbody>
                                  <tr v-for="(checking,index) in checkings">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ checking.name }}</td>
                                        
                                        <td>{{ checking.phone }}</td>
                                        <td>{{ checking.age }}</td>
                                        <td>{{ checking.phoneID }}</td>
                                        <td>
                                            <router-link :to="'/refer/edit/'+checking.id"   class="btn blue darken-3">Edit</router-link>
                                            <button @click="showDetail(checking)" class="btn blue darken-3">Detail</button>
                                            
                                        </td>
                                
                                </tr>
                            </tbody>
                            
                         </table>
                    <div class="row center" style="margin-top:10px;">
                              <loading v-if="loading"></loading>
                    </div>
                </div>
                  <div class="row center" v-if="!loading && (checkings.length<checking_count)">
                    <button class="btn blue darken-2" @click="loadMore">Load More</button>
                </div>
                     
              
                  
             </div>
             <detail @close="detailShow=false" v-bind:show="detailShow"  v-bind:detailData="detailData" ></detail>
      </div>
</template>

<script>

import Loading from '@/components/Partials/Loading.vue';
import Detail from '@/components/Patient/Refer/Detail.vue';

import BackContainer from '@/components/ReUse/BackContainer.vue';

export default {
  name: 'ConfirmedList',
  data () {
    return {
        search:"",
        detailShow:false,
        detailData:null,
    }
  },
  mounted()
  {
      
    this.$store.dispatch("clearCheckings");
     this.getData();
  },
  methods: {
    loadMore()
    {
        this.getData(true);
    },
     searchCheckings()
     {
            
             this.$router.push({name:"CheckingsSearch",params:{search:this.search}});

     },
    getData(load=false)
    {
         var data={
          lastid:0,
          load:load,
          township_id:this.$route.params.township_id,
          status:7,
          confirmed:1
        };

        if (this.checkings.length>0)
        {
            data.lastid=this.checkings.length;
        }

      
      

        if (this.$route.params.status)
        {
            data.status=this.$route.params.status;
            if (!data.load)
            {
                data.lastid=0;
            }

            data.confirmed=true;
            
        }


     
        
          this.$store.dispatch("getCheckings",data);
    },

    showDetail(value)
    {
        this.detailShow=true;
        this.detailData=value;
    },
    recoverChecking(item)
    {
        this.$store.dispatch("recoverChecking",{id:item.id});
    },
    excelExport()
    {
        this.$store.dispatch("exportDeletedPatient",{township_id:this.$route.params.township_id});
    }
  },
  components: {
    "loading":Loading,
    
     "detail":Detail,
    "back-container":BackContainer,
  },
  computed:
  {
      checkings()
      {
          return this.$store.getters.checkings;
      },
      loading()
      {
          return this.$store.getters.loading;
      },
      checking_count()
      {
          return this.$store.getters.checking_count;
      },
      title()
      {
          if (this.$route.params.status==4)
          {
              return "Cannot Contact List";
          }
          else if (this.$route.params.status==5)
          {
              return "Fake List";
          }
          else if (this.$route.params.status==7)
          {
              return "PA Deleted List";
          }
          else 
          {
              return "Wrong Township List";
          }
      },
      confirmCheckingLoading()
      {
          return this.$store.getters.confirmCheckingLoading;
      },
      confirmCheckingFinish()
      {
          return this.$store.getters.confirmCheckingFinish;
      }
  },
   watch:{
    $route (to, from){
       this.getData();
     },
     confirmCheckingFinish(val)
     {
         if (val)
         {
             location.reload();
         }
     }
    } ,
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .checking_list 
  {
      padding-left:20px;
      padding-right:20px;
      padding-top:30px;
  }

  .checking_list .card-content 
  {
      padding:10px;
  }
</style>
